import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c93b7e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  align: "center"
}

import { useI18n } from "vue-i18n"
import { onBeforeUnmount, ref, computed } from "vue"
import { Hospital } from "@/types"
import { onMounted } from "vue"
import { useRoute } from "vue-router"
import { useUserActions } from "@/stores/user-actions"
import { useToast } from "vue-toast-notification"
import FooterComponent from "@/components/Footer/FooterComponent.vue"
import HeaderComponent from "@/components/Header/HeaderComponent.vue"
import HospitalPersonalInfo from "./HospitalInfo/HospitalPersonalInfo.vue"
import HospitalSpecialInfo from "./HospitalInfo/HospitalSpecialInfo.vue"
import { useMeta } from "vue-meta"


export default /*#__PURE__*/_defineComponent({
  __name: 'HospitalStudentProfile',
  setup(__props) {

const { t } = useI18n()
const route = useRoute()
const id = ref()
const userAction = useUserActions()
const isLoading = ref(true)
const hospital = ref<Hospital | undefined>(undefined)
const responseStatus = ref({})
const smallWindow = ref(window.innerWidth < 1000)
const $toast = useToast()
onMounted(() => {
  id.value = route.params.id
  localStorage.removeItem("hospitalId")
  getHospitalProfile()

  window.addEventListener("resize", updateWindowSize)
})

useMeta(
  computed(() => ({
    title: hospital.value?.name ?? "Medcircle",
  }))
)

const updateWindowSize = (): void => {
  smallWindow.value = window.innerWidth < 1000
}

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateWindowSize)
})

// const buildTimeArray = (totalTime: string[]) => {
//   let firstDate = new Date(totalTime[0])

//   totalTime.slice(1, -1).forEach((date, index) => {
//     availableDatesArray.value = [firstDate]

//     const thisDate = new Date(date)
//     const nextDate = new Date(totalTime[index + 2])

//     const differenceInDays = Math.abs(
//       (nextDate.getTime() - thisDate.getTime()) / (1000 * 3600 * 24)
//     )

//     if (differenceInDays > 1) {
//       availableDatesArray.value.push(thisDate)

//       twoDimensionalDateArray.value.push(availableDatesArray.value)

//       availableDatesArray.value = []
//       firstDate = nextDate
//     } else if (index == totalTime.length - 3) {
//       availableDatesArray.value.push(nextDate)

//       twoDimensionalDateArray.value.push(availableDatesArray.value)
//     }
//   })
//   modelDateArray.value = twoDimensionalDateArray.value
// }

// useMeta(
//   computed(() => ({
//     title: `${doctorName.value ?? ""}
//         ${doctor.value?.clinicLocation ?? "Medcircle"}
//         ${doctorSpecialty.value ?? ""}`,
//     description: `${t("meta.doctor-description")} ${doctorName.value} - ${
//       doctorSpecialty.value
//     } `,

//     meta: [
//       { name: "viewport", content: "user-scalable=no" },
//       {
//         property: "og:title",
//         content:
//           doctorName.value +
//           " " +
//           doctor.value?.clinicLocation +
//           " " +
//           doctorSpecialty.value,
//       },
//       { property: "og:image", content: doctor?.value?.photo },
//       {
//         property: "og:type",
//         content: `website`,
//       },
//       {
//         property: "og:description",
//         content: `${t("meta.doctor-description")} ${doctorName.value} - ${
//           doctorSpecialty.value
//         } `,
//       },
//       {
//         property: "og:url",
//         content: `https://medcircle.eu/doctors/${id.value}`,
//       },
//       {
//         property: "og:site_name",
//         content: `medcircle`,
//       },
//     ],
//   }))
// )

const getHospitalProfile = async (): Promise<void> => {
  const response = await userAction.getSingleHospital(id.value)

  responseStatus.value = response
  if (response.success) {
    hospital.value = response.result as Hospital
  }
  isLoading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_request_status = _resolveComponent("request-status")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderComponent),
    _createVNode(_component_request_status, {
      response: responseStatus.value,
      isLoading: isLoading.value
    }, null, 8, ["response", "isLoading"]),
    (!isLoading.value && hospital.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_row, { class: "mt-5" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: smallWindow.value ? 12 : 5
              }, {
                default: _withCtx(() => [
                  _createVNode(HospitalPersonalInfo, { hospital: hospital.value }, null, 8, ["hospital"])
                ]),
                _: 1
              }, 8, ["cols"]),
              _createVNode(_component_v_col, {
                cols: smallWindow.value ? 12 : 7
              }, {
                default: _withCtx(() => [
                  _createVNode(HospitalSpecialInfo, { hospital: hospital.value }, null, 8, ["hospital"])
                ]),
                _: 1
              }, 8, ["cols"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(FooterComponent)
  ], 64))
}
}

})